/** @jsxImportSource @emotion/react */
import { Navigate, Route, Routes } from 'react-router-dom';
import { Send, Details } from './Send';
import { SendProvider } from './Send/context';
import { Wallet as MerchantWallet } from './Wallet';

export const Wallet = () => {
  return (
    <SendProvider>
      <Routes>
        <Route path="/" element={<MerchantWallet />}>
          <Route path=":wallet" element={<Send />}>
            <Route path="" element={<Navigate to="details" />} />
            <Route path="details" element={<Details />} />
          </Route>
        </Route>
      </Routes>
    </SendProvider>
  );
};
